if (!customElements.get('rt-discover')) {
 customElements.define('rt-discover', class extends HTMLElement {
  connectedCallback() {
   this.controller = new AbortController();
   this.addEventListener('click', async event => {
    const link = event.target.closest('[data-browse-next]');
    if (!link || !this.contains(link) || this.fallback || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    if (this.loading) return;
    this.loading = true;
    const original = link.textContent;
    link.textContent = link.dataset.loading;
    link.setAttribute('aria-disabled', 'true');
    const grid = this.querySelector('[data-browse-grid]');
    grid.setAttribute('aria-busy', 'true');
    try {
     const url = new URL(link.href, location.origin);
     if (url.origin !== location.origin) throw new Error('origin');
     url.searchParams.set('section_id', this.dataset.section);
     const response = await fetch(url, {signal: this.controller.signal});
     if (!response.ok) throw new Error('response');
     const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
     const next = doc.querySelector('rt-discover');
     const items = next?.querySelectorAll('[data-browse-item]');
     const footer = next?.querySelector('[data-browse-footer]');
     if (!items?.length || !footer) throw new Error('content');
     grid.append(...items);
     this.querySelector('[data-browse-footer]').replaceWith(footer);
     items[0].focus({preventScroll:true});
     items[0].scrollIntoView({block:'start',behavior:'instant'});
    } catch (error) {
     if (error.name !== 'AbortError') {
      this.fallback = true;
      link.textContent = original;
      link.removeAttribute('aria-disabled');
      this.querySelector('[data-browse-status]').textContent = this.dataset.error || 'Please follow the link to continue browsing.';
     }
    } finally {
     this.loading = false;
     grid.removeAttribute('aria-busy');
    }
   }, {signal:this.controller.signal});
  }
  disconnectedCallback() { this.controller?.abort(); }
 });
}
